const Error = () => (
  <div className='centered-container'>
    <div className='success-content'>
      <img
        src='error.svg'
        className='svg-illustration'
        alt='Error illustratie'
      />
      <div className='success-text-wrapper'>
        <h3>Er is iets misgegaan</h3>
        <p>
          U kunt het opnieuw proberen door op de knop hieronder te drukken. Komt
          u steeds op deze pagina terecht? Neem dan contact met ons op door te
          mailen naar info@klusminuten.nl
        </p>
      </div>
      <button className='button' onClick={() => false}>
        Opnieuw proberen
      </button>
    </div>
  </div>
);

export default Error;
